import * as url from "../url.helper";

import { post } from "../api.helper";

export const addlistingPreference = data => post(url.ADD_LISTING_PREFERENCE, data);

export const getlistingPreference = data => post(url.GET_LISTING_PREFERENCE, data);

export const editlistingPreference= data => post(url.EDIT_LISTING_PREFERENCE, data);

export const deletelistingPreference= data => post(url.DELETE_LISTING_PREFERENCE, data);
